<template>
  <div>
    <div class="filter" style="border-bottom: 2px solid #335667">
      <el-form :model="filter" label-width="50px" label-position="top">
        <el-form-item label="年份">
          <el-date-picker
            size="small"
            type="years"
            value-format="yyyy"
            v-model="filter.years"
            placeholder="可多选"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="
              getStatistics()
              getDurationStatistics()
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="流程">
          <el-select
            v-model="flow_ids"
            :collapse-tags="true"
            multiple
            size="small"
            clearable
            filterable
            @change="getDurationStatistics()"
          >
            <el-option
              v-for="(v, k) in flowOptions"
              :key="k"
              :value="parseInt(k)"
              :label="v"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="mt-20">
      <el-table
        size="mini"
        :data="flowDuration"
        v-loading="durationLoading"
        show-summary
        stripe
        border
        sum-text="Total"
        :header-cell-style="{
          background: '#37717b',
          color: '#fff',
        }"
        style="width: fit-content"
      >
        <el-table-column label="时长" prop="name" width="120px">
          <template slot-scope="scope">
            {{ flowDurationStepName[scope.row.name] }}
          </template>
        </el-table-column>
        <el-table-column label="未完成" prop="1990" align="right" width="120px">
          <template slot-scope="scope">
            <div
              class="text-primary pointer"
              @click="
                handleSelect({
                  date_type: scope.row.name,
                  status: 2,
                  years: filter.years,
                })
              "
            >
              {{ scope.row['1990'] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="year + '已完成'"
          :prop="year"
          align="right"
          :key="year"
          v-for="year in years"
          width="120px"
        >
          <template slot-scope="scope">
            <div
              class="text-primary pointer"
              @click="
                handleSelect({
                  date_type: scope.row.name,
                  status: 1,
                  date: year,
                })
              "
            >
              {{ scope.row[year] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Total"
          align="right"
          prop="total"
          width="120px"
        ></el-table-column>
      </el-table>
    </div>

    <div class="mt-20">
      <div
        style="
          margin-top: 40px;
          margin-bottom: 10px;
          font-weight: 500;
          line-height: 2;
          display: flex;
          justify-content: space-between;
        "
      >
        {{ detailCondition }}流程明细
        <el-button
          size="mini"
          type="primary"
          plain
          @click="handleExport"
          :loading="downloading"
          >导出</el-button
        >
      </div>
      <el-table
        size="mini"
        :header-cell-style="{
          background: '#37717b',
          color: '#fff',
        }"
        :data="quests"
        v-loading="questLoading"
        stripe
        border
      >
        <el-table-column label="NCR" align="center">
          <template slot-scope="scope">
            <service-quest-link
              :id="scope.row.id"
              :number="scope.row.number || '-'"
              routePath="/dashboard/service_quests/list"
              target="_blank"
            ></service-quest-link>
          </template>
        </el-table-column>
        <el-table-column
          label="最终客户"
          align="center"
          prop="customer.name"
          min-width="180px"
        ></el-table-column>
        <el-table-column
          label="设备序列号"
          prop="device.serial_number"
          align="center"
        ></el-table-column>
        <el-table-column
          label="耗时(工作日)"
          prop="total_day"
          align="center"
        ></el-table-column>
        <el-table-column
          label="流程名称"
          prop="flow.name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="当前步骤"
          align="center"
          v-if="questStatus == 2"
        >
          <template slot-scope="scope">
            {{ scope.row.current_step.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="当前执行人"
          align="center"
          v-if="questStatus == 2"
        >
          <template slot-scope="scope">
            {{ scope.row.director.name || '待领取' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { serviceQuestStatistics } from '@/service/getData'

export default {
  computed: {
    flowDuration() {
      let flowYears = this.groupBy(this.durationStatistics, function (item) {
        return [item.step_name]
      })

      let data = flowYears.map((arr) => {
        let row = {
          name: parseInt(arr[0].step_name),
          total: 0,
        }
        arr.map((item) => {
          row[item.format_date] = item.total
          row.total += item.total
        })
        return row
      })

      data.sort(function (a, b) {
        return a.name - b.name
      })
      return data
    },
  },
  data() {
    return {
      loading: false,
      durationLoading: false,
      downloading: false,
      durationStatistics: [],
      filter: {
        featrue_type: 1, //统计维度
        date_type: 1, //时间颗粒度
        years: [new Date().getFullYear().toString()],
      },
      flow_ids: [],
      flowOptions: {},
      pickerOptions: {},
      years: [],
      questLoading: false,
      quests: [],
      questStatus: 0,
      flowDurationStepName: {
        1: 'T≤2W',
        2: '2W<T≤4W',
        3: '4W<T≤6W',
        4: '6W<T≤3M',
        5: 'T>3M',
      },
      detailCondition: '',
    }
  },
  created() {
    let that = this
    this.pickerOptions = {
      disabledDate: function (time) {
        return (
          that.$time(new Date()).isBefore(time) ||
          that.$time(time).isBefore('2025-01-01')
        )
      },
    }
    this.getStatistics()
    this.getDurationStatistics()
  },
  methods: {
    chartHandleEvents(e) {
      this.$emit('tab', { flow_id: e.data.flow_id })
    },
    async handleSelect(condition = {}) {
      this.detailCondition =
        this.flowDurationStepName[condition.date_type] +
        `（${condition.date ? `${condition.date}已完成` : '未完成'}）`
      condition.featrue_type = 6
      condition.flow_ids = this.flow_ids

      this.questLoading = true
      this.questStatus = condition.status
      let res = await serviceQuestStatistics(condition)
      this.questLoading = false
      this.quests = res.data
    },
    async getStatistics() {
      if (this.filter.years.length == 0) {
        this.$alert('请至少选择一个年份!')
        return
      }
      if (this.filter.years.length > 0) {
        this.filter.years.sort()
      }
      let data = this.clone(this.filter)
      this.loading = true
      let res = await serviceQuestStatistics(data)

      let flowOptions = {}
      this.years = this.filter.years
      this.statistics = res.data

      res.data.map((item) => {
        if (!flowOptions[item.service_quest_flow_id]) {
          flowOptions[item.service_quest_flow_id] = item.flow.name || '无'
        }
      })
      this.flowOptions = flowOptions
      this.loading = false
    },

    async getDurationStatistics() {
      if (this.filter.years.length == 0) {
        this.$alert('请至少选择一个年份!')
        return
      }
      if (this.filter.years.length > 0) {
        this.filter.years.sort()
      }
      let data = this.clone(this.filter)
      data.featrue_type = 5
      data.flow_ids = this.flow_ids
      this.durationLoading = true
      let res = await serviceQuestStatistics(data)
      this.durationStatistics = res.data
      this.quests = []
      this.durationLoading = false
    },

    handleExport() {
      if (this.downloading) return
      this.downloading = true
      import('@/vendor/Export2Excel').then((excel) => {
        let tHeader = [
          'NCR',
          '最终客户',
          '设备序列号',
          '耗时(工作日)',
          '流程名称',
        ]
        if (this.questStatus == 2) {
          tHeader = tHeader.concat(['当前步骤', '当前执行人'])
        }

        let data = []
        this.quests.map((item) => {
          let rowData = [
            item.number || '-',
            item.customer.name,
            item.device.serial_number,
            item.total_day,
            item.flow.name,
          ]
          if (this.questStatus == 2) {
            rowData.push(item.current_step.name)
            rowData.push(item.director.name || '待领取')
          }
          data.push(rowData)
        })

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${this.detailCondition
            .replace('<', '小于')
            .replace('>', '大于')}流程明细`,
        })
        this.downloading = false
      })
    },
  },
}
</script>
